export const EMAIL_INTERVAL = 60
export const EMAIL_CODE_LENGTH = 6
export const LOGIN_METHOD_MAP = {
    email: 'Email',
    evm: "EVM",
    sol: "SOL",
    btc: "BTC",
    ton: "TON",
    tron: "TRON",
    google: "Google",
    facebook: "Facebook",
    x: "X",
    telegram: "Telegram",
    github: "Github",
    discord: "Discord",
    linkedin: "LinkedIn",
    youtube: "Youtube",
}

export const NATIVE_TOKEN_ADDRESS = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
